<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :expand-config="{ reserve: true }"
      resizable
      border
      row-config.keyField
      row-id="shipmentBatchCode"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:batchAmount="{ row }">
        <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span>
          {{ row.v_batchSalePriceAmount || 0 }}
          {{ row.v_salesCurrencyUnit }}
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tip_content_back') || '回退'"
            placement="top"
          >
            <i
              class="el-icon-refresh-left tool-btn"
              @click="fallback([row.shipmentBatchCode])"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <back-form
      :visible.sync="backFormDialogVisible"
      :shipmentBatchCodeList="backFormDialogOption.shipmentBatchCodeList"
      :title="backFormDialogOption.title"
      @reload="() => this.$emit('reload')"
      @clearCheckboxRows="clearRows"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import BackForm from '../back-form'

export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { BackForm },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      backFormDialogVisible: false,
      backFormDialogOption: {
        shipmentBatchCodeList: [],
        title: this.$l('form_back_reason') || '回退原因',
      },
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    getCheckboxRecords() {
      const $table = this.$refs.table
      const records = $table.getCheckboxRecords()
      const reserves = $table.getCheckboxReserveRecords()
      return records.concat(reserves)
    },
    clearRows() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    clearCheckboxRows(e) {
      const data = this.getCheckboxRecords()
      if (!e || !e.length || !data || !data.length) return
      const rows = data.filter(
        (i) => e.findIndex((j) => i.orderBatchCode === j.orderBatchCode) >= 0
      )
      this.$refs.table.setCheckboxRow(rows, false)
      this.$emit('checkbox-change', this.getCheckboxRecords())
    },
    fallback(shipmentBatchCodeList) {
      this.$confirm(
        this.$l('tips_pending_rollback') || '是否要回退待处理订单批次？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.backFormDialogVisible = true
        this.backFormDialogOption.shipmentBatchCodeList = shipmentBatchCodeList
      })
    },
    batchFallback() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_select_fallback_data') ||
            '请选择需要回退的数据',
          type: 'warning',
        })
        return
      }
      const listCode = data.map((item) => {
        return item.shipmentBatchCode
      })
      this.fallback(listCode)
    },
  },
}
</script>
